// |-- Built-in Dependencies --|
import React, { useState } from "react";

// |-- External Dependencies --|
import { useDispatch, useSelector } from "react-redux";

// |-- Internal Dependencies --|
import DispositionListView from "../../Components/DispositionListView";
import { showToast } from "src/utils/showToaster";

// |-- Redux --|
import { RootState, AppDispatch } from "src/redux/store";
import {
  setSearchValue,
  setSelctedLocationState,
  setFilterValue,
} from "src/redux/slices/DispositionLevelTwoSlice";
import { useDeleteDispositionLevelTwoMutation } from "src/services/DispositionLevelTwoServices";
import EditDispositionLevelTwoFormWrapper from "../Edit/EditDispositionLevelTwoFormWrapper";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";

// |-- Types --|
type Props = {
  states: any[];
  onAddNew: () => void;
};

const DispositionLevelTwoListing = ({ states, onAddNew }: Props) => {
  const [setselectedDispositionSecondId, setsetselectedDispositionSecondId] =
    useState<string>("");

  const [isOpenEditForm, setIsOpenEditForm] = useState(false);

  const [deleteDispositionLevelTwo] = useDeleteDispositionLevelTwoMutation();

  const dispatch = useDispatch<AppDispatch>();
  const { searchValue }: any = useSelector((state: RootState) => state.states);
  const { selectedLocationCountries }: any = useSelector(
    (state: RootState) => state.dispositionLevelOne
  );

  const { selectedLocationState }: any = useSelector(
    (state: RootState) => state.dispositionLevelTwo
  );

  function handleDispositionLevelTwoClick(newValue: any) {
    if (selectedLocationState?.value === newValue.value) {
      dispatch(setSelctedLocationState(null));
    } else {
      dispatch(setSelctedLocationState(newValue));
    }
  }

  return (
    <>
      <DispositionListView
        searchValue={searchValue}
        OnSearchChange={(newValue) => dispatch(setSearchValue(newValue))}
        listHeading="Disposition Two"
        listData={states}
        hideAddButton={!isCheckActionsPermission({
          moduleName: UserModuleNameTypes.DISPOSITION,
          actionName: UserModuleActionTypes.DISPOSITION_TWO_ADD,
        })}
        onAddClick={() => {
          // onAddNew();
          if (!selectedLocationCountries) {
            showToast("error", "Please select disposition level one");
          } else {
            onAddNew();
          }
        }}
        onListItemClick={(newValue) => {
          if (selectedLocationCountries !== null) {
            handleDispositionLevelTwoClick(newValue);
          }
        }}
        onOuterGetActionDeleteClick={(value: {
          label: string;
          value: string;
        }) => {
          if (!selectedLocationCountries) {
            showToast("error", "Please select disposition level one");
          } else {
            deleteDispositionLevelTwo(value?.value).then((res: any) => {
              if (res?.error) {
                showToast("error", res?.error?.data?.message);
              } else {
                if (res?.data?.status) {
                  showToast("success", "delete successfully");
                  setFilterValue("");
                } else {
                  showToast("error", res?.data?.message);
                }
              }
            });
          }
        }}
        onOuterGetActionEditClick={(value) => {
          if (!selectedLocationCountries) {
            showToast("error", "Please select disposition level one");
          } else {
            setIsOpenEditForm(true);
            setsetselectedDispositionSecondId(value?.value);
          }
        }}
        disabled={false}
      />
      {isOpenEditForm ? (
        <EditDispositionLevelTwoFormWrapper
          dispositionLevelSecondId={setselectedDispositionSecondId}
          onClose={() => setIsOpenEditForm(false)}
        />
      ) : null}
    </>
  );
};

export default DispositionLevelTwoListing;
